<template>
  <div>
    <transition name="slide">
        <div v-if="showCookies" class="cookies">
          <div class="slides">
            <section class="cookies slide overlay is-flex">
              <div class="container">
                <div class="center-fix">
                  <p>{{ pageDescription }}</p>
                  {{$t('cookiesBanner.phrase')}}<span class="nobreak">{{ pageTitle }}</span> <a @click="openCookies" target="_blank"> {{$t('cookiesBanner.phrase2')}}</a>.
                </div>
              </div>
              <a @click="toggleCookies(false)"><i class="close-button fal fa-times"></i></a>
            </section>
          </div>
        </div>
      </transition>
  </div>
</template>

<script>
import auth from '@/mixins/auth'
import localStorage from 'store'
import link from '@/mixins/link'
import componentState from '@/mixins/component-state'

const cookieKey = 'cookies_banner'

export default {
  components: {
  },
  mixins: [auth, link, componentState],
  data: function () {
    return {
      showCookies: false
    }
  },
  created: function () {
    this.checkShowCookies()
  },
  computed: {
    pageTitle: function () {
      switch (this.appName) {
        case 'ysc':
        case 'isef':
        case 'ohiosci':
        case 'societyforsciencebcm':
        case 'oasam':
          return 'ProjectBoard'
        case 'neweng':
          return 'engineering.com'
        case 'buckeye':
          return 'Buckeye'
        default:
          return 'Make: Projects'
      }
    },
    pageDescription: function () {
      switch (this.appName) {
        case 'buckeye':
          return 'The Buckeye Science & Engineering Fair (BSEF) provides all Ohio’s students in grades 9-12 with an opportunity to qualify for the International Science & Engineering Fair.'
        default:
          return ''
      }
    },
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    }
  },
  methods: {
    toggleCookies: function (show) {
      this.showCookies = show
      if (this.isLoggedIn) {
        const settings = { showCookies: show }
        this.$store.dispatch('updateUserSettings', { username: this.currentUser.userName, settings })
      } else {
        localStorage.set(cookieKey, this.showCookies)
      }
      this._callback('unshiftChristmasLights')
    },
    checkShowCookies: function () {
      if (this.isLoggedIn) {
        this.$store.dispatch('getUserSetting', 'showCookies').then((value) => {
          this.showCookies = !!value
        })
      } else {
        const show = localStorage.get(cookieKey)
        this.showCookies = show !== undefined ? show : true
      }
      return this.showCookies
    },
    openCookies: function () {
      this.link('/cookies')
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .cookies {
    z-index: 10;
    text-align: center;
    position: fixed;
    align-items: center;
    a {
      font-weight: bold;
    }
  }

  .center-fix {
    font-size: 0.8rem;
    padding: 5px;
  }

  .overlay {
    width: 100%;
    height: auto;
    background-color: white;
    opacity: 0.8;
  }

  .nobreak {
    white-space: nowrap;
  }

  .slide {
    background-position: center 20%;
    @include fullhd {
      background-position: 0 30%;
    }
  }

  .container {
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .slide-leave-active {
    &.cookies, .cookies {
      transition: height 0.5s ease;
    }
    .container, .close {
      transition: opacity 0.3s ease;
    }
  }

  .slide-leave-to {
    &.cookies, .cookies {
      height: 0;
    }
    .container, .close {
      opacity: 0;
    }
  }

  .close-button {
    font-size: 0.8rem;
    margin: 10px 1.5rem 0;
  }

  @include mobile {
    .center-fix {
      font-size: 0.7rem;
    }
    .close-button {
      margin-right: 0.6rem;
    }
  }

  @include mobile {
    .cookies {
      align-items: flex-start;
    }
    .center-fix {
      font-size: 0.7rem;
    }
    .close-button {
      &.is-stories {
        margin-right: 0.6rem;
      }
    }
  }
</style>
